import { render, staticRenderFns } from "./AdministrationTop.vue?vue&type=template&id=a46e3b8c&"
import script from "./AdministrationTop.vue?vue&type=script&lang=js&"
export * from "./AdministrationTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports